import CommonService from "../Common";
import { AxiosRequestConfig } from "axios";

interface Settings {
  pathPrefix?: string;
  commonService: CommonService;
}

interface NotificationSettings {
  userId: string;
  emailNotifications: boolean;
}

interface AccountDeletionRequest {
  userId: string;
  confirmDeletion: true;
}

class SettingsService implements Settings {
  pathPrefix?: string;
  commonService: CommonService;

  constructor() {
    this.pathPrefix = "/api/v1/settings";
    this.commonService = new CommonService();
  }

  // Get user settings
  getSettings(userId: string | any) {
    const config: AxiosRequestConfig = {
      method: "GET",
      url: `${this.pathPrefix}/notifications/${userId}`,
      withCredentials: true,
    };
    return this.commonService.fetch(config);
  }

  // Update notification settings
  updateNotifications(notificationSettings: NotificationSettings) {
    const config: AxiosRequestConfig = {
      method: "PUT",
      url: `${this.pathPrefix}/notifications`,
      data: notificationSettings,
      withCredentials: true,
    };
    return this.commonService.fetch(config);
  }

  // Request account deletion
  requestAccountDeletion(deletionRequest: AccountDeletionRequest) {
    const config: AxiosRequestConfig = {
      method: "DELETE",
      url: `${this.pathPrefix}/user/delete`,
      data: deletionRequest,
      withCredentials: true,
    };
    return this.commonService.fetch(config);
  }
}

export default SettingsService;
